var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPencil = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m12.631 6.275.77-.771c.801-.8.801-2.103 0-2.904A2.04 2.04 0 0 0 11.95 2c-.55 0-1.065.213-1.452.6l-.77.77 2.903 2.905ZM9.057 4.04 3.35 9.748a1.109 1.109 0 0 0-.268.434L2.024 13.38a.473.473 0 0 0 .599.599l3.196-1.059c.163-.053.314-.146.435-.268l5.707-5.707-2.904-2.903Z",
  fill: "#fff"
})));
export default SvgPencil;